import "/app/node_modules/.pnpm/core-js@2.6.12/node_modules/core-js/modules/es6.array.iterator.js";
import "/app/node_modules/.pnpm/core-js@2.6.12/node_modules/core-js/modules/es6.promise.js";
import "/app/node_modules/.pnpm/core-js@2.6.12/node_modules/core-js/modules/es6.object.assign.js";
import "/app/node_modules/.pnpm/core-js@2.6.12/node_modules/core-js/modules/es7.promise.finally.js";
import Vue from 'vue';
import 'normalize.css/normalize.css'; // A modern alternative to CSS resets

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueClipboard from 'vue-clipboard2';
import '@/styles/index.scss'; // global css
import AFTableColumn from 'af-table-column';
import App from "./App";
import store from "./store";
import router from "./router";
import _i18n from "./i18n";
import '@/icons'; // icon
import '@/permission'; // permission control
import i18nDirective from '@/directives/i18n';

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
if (process.env.NODE_ENV === 'production') {
  var _require = require("../mock"),
    mockXHR = _require.mockXHR;
  mockXHR();
}
Vue.use(VueClipboard);
// set ElementUI lang to EN
Vue.use(ElementUI, {
  i18n: function i18n(key, value) {
    return _i18n.t(key, value);
  }
});
Vue.use(AFTableColumn);
Vue.config.productionTip = false;
Vue.directive('i18n', i18nDirective);
new Vue({
  el: '#app',
  i18n: _i18n,
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
});